import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Typography } from "@mui/material";
import moment from "moment";
import { useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import {
  addUpdateTemplateByDiagnosticId,
  createDiagnosticsWoLoader,
  deleteDiagnosticsByIdWoLoader,
  getPetsCompliantSummaryWoLoader,
  updateDiagnosticsWoLoader,
} from "../../../../redux/reducers/petSlice";
import { uploadFilesAndGetUrlWoLoader } from "../../../../redux/reducers/planSlice";
import { AppColors } from "../../../../util/AppColors";
import { a4PrintConfig } from "../../../../util/commonConfig";
import { doneAtList, modalities, sampleTypes } from "../../../../util/dropList";
import { diagStatusEnum, genderEnum } from "../../../../util/enum";
import { urlToFile } from "../../../../util/function";
import DiagnosticAddUpdate from "../../../CommonScreens/Diagnostic/DiagnosticAddUpdate";
import DiagnosticReport from "../../../CommonScreens/Diagnostic/DiagnosticReport";

const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
const plusBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const delBtn = { color: AppColors.red, width: 20, height: 20 };

const nameExpan = {
  type: "Select Type",
  testName: "Test Name",
  variant: "Variant",
  dueDate: "Due Date",
  remarks: "Remarks",
  doneAt: "Done At",
  sampleType: "Sample Type",
  processingTime: "Processing Time",
  modality: "Modality",
  device: "Device",
  priority: "Priority",
  status: "Status",
  collectionTime: "Collection Time *",
  collectedBy: "Collected by *",
};

const initialValues = {
  type: "Lab",
  testName: null,
  dueDate: new Date(),
  remarks: "",
  files: [],
  price: 0,
  tax: 0,
  sampleCollected: false,
  doneAt: doneAtList?.[0]?.value,
  collectionTime: new Date(),
  priority: "Routine",
  sampleCollected: false,
  collectedBy: null,
  quantity: 1,
  // status: "In Progress",
};

const initialErrors = {
  type: false,
  dueDate: false,
  remarks: false,
  collectedBy: false,
};
const initialHelpers = { type: "", dueDate: "", remarks: "", collectedBy: "" };
const defaultFile = {
  question: "File Upload",
  questionType: "fileupload",
  required: false,
  answer: ["file"],
  vitalGroupId: null,
  vitalId: null,
  delete: false,
  questionId: null,
};
const ckEditorBuild =
  typeof ClassicEditor?.create === "function"
    ? ClassicEditor
    : ClassicEditor?.default;

const PetDiagnostics = () => {
  const dispatch = useDispatch();
  const contentToPrint = useRef(null);
  const printTitleRef = useRef("");
  const location = useLocation();
  const { appointment } = location.state || {};
  const [modVisible, setModVisible] = useState(false);
  const [isEditModal, setEditModal] = useState(false);
  const [fileError, setFileError] = useState(false);
  // const [templateFileError, setTemplateFileError] = useState(false);
  const [diagnosticsId, setDiagnosticsId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [tempSelectedItem, setTempSelectedItem] = useState(null);
  const [diagValues, setDiagValues] = useState(initialValues);
  const [delModVsble, setDelModVsble] = useState(false);
  const [reportDownVsble, setReportDownVsble] = useState(false);
  const [diagnosticsHelpers, setDiagnosticsHelpers] = useState(initialHelpers);
  const [diagnosticsErrors, setDiagnosticsErrors] = useState(initialErrors);
  const [tempModVsble, setTempModVsble] = useState(false);
  const [templatevalues, setTemplateValues] = useState({});
  const {
    diagTemplateById,
    vitalsByIds,
    services: serviceList,
    selectedClinicBranch,
    details: clinicDetails,
  } = useSelector((state) => state?.clinic);
  const clinicVets = useSelector((state) => state?.vet?.vetList?.vets);
  // const vets = useSelector((state) => state?.vet?.vets);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const role = localStorage.getItem("role");
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    services: clinicServiceList,
    vets: vetList,
    clinic: clinicDataDet,
  } = useMemo(() => {
    if (!mandateDataRaw) {
      return { services: [], vets: [], clinic: {} };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        clinic: reqData?.clinic ?? {},
      };
    } catch {
      return { services: [], vets: [], clinic: {} };
    }
  }, [mandateDataRaw]);
  const services =
    role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
      ? // apntDet?.appointment?.hospitalId !== clinic?.id
        (serviceList?.data ?? [])
      : (clinicServiceList ?? []);
  const vets =
    role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
      ? (clinicVets ?? [])
      : (vetList ?? []);
  const clinicDet = clinicDataDet?.id ? clinicDataDet : clinicDetails;

  const callApi = () => {
    dispatch(
      getPetsCompliantSummaryWoLoader(appointment?.appoinment?.appointmentId),
    );
  };

  const getTableRecords = () => {
    return apntDet?.diagnostics
      ?.filter(
        (li) =>
          // apntDet?.appointment?.inpatient ||
          // li?.dueDate === apntDet?.appointment?.appointmentDate &&
          li?.appoinment?.appointmentId === apntDet?.appointment?.appointmentId,
      )
      ?.sort((a, b) => {
        const aid = Number(a?.diagonosticId);
        const bid = Number(b?.diagonosticId);
        return (
          (Number.isFinite(aid) ? aid : 0) - (Number.isFinite(bid) ? bid : 0)
        );
      });
  };

  const diagnosticReportHeaderRows = useMemo(() => {
    const pet = apntDet?.pet;
    const appt = apntDet?.appointment;
    const referredRaw = appt?.doctorName;
    const referredBy = Array.isArray(referredRaw)
      ? referredRaw?.[0]
      : referredRaw;
    let loggedInName = "-";
    try {
      const raw = localStorage.getItem("user");
      if (raw) {
        const p = JSON.parse(raw);
        loggedInName =
          [p?.salutation, p?.name].filter(Boolean).join(" ").trim() ||
          p?.userName ||
          p?.email ||
          "-";
      }
    } catch {
      loggedInName = "-";
    }
    const agePart = pet?.dob ? moment(pet.dob).fromNow(true) : "";
    const sexPart = genderEnum?.[pet?.gender ?? ""];
    const ageSex =
      agePart && sexPart
        ? `${agePart} / ${sexPart}`
        : agePart || sexPart || "-";

    return [
      {
        leftLabel: "Lab Order ID:",
        leftValue:
          tempSelectedItem?.labOrderId ?? tempSelectedItem?.labOrderNo ?? "-",
        rightLabel: "Date:",
        rightValue: tempSelectedItem?.dueDate
          ? moment(tempSelectedItem.dueDate).format("DD-MM-YYYY")
          : "-",
      },
      {
        leftLabel: "Patient Reg. No:",
        leftValue: pet?.registrationNo ?? appt?.registrationNo ?? "-",
        rightLabel: "Vet Name:",
        rightValue: referredBy ?? "-",
      },
      {
        leftLabel: "Parent Name:",
        leftValue: pet?.userName ?? "-",
        rightLabel: "Species:",
        rightValue: pet?.petType ?? "-",
      },
      {
        leftLabel: "Pet Name:",
        leftValue: pet?.petName ?? "-",
        rightLabel: "Breed:",
        rightValue: pet?.breed ?? "-",
      },
      {
        leftLabel: "Lab Technician / Pathologist:",
        leftValue: loggedInName,
        rightLabel: "Age / Sex:",
        rightValue: ageSex,
      },
    ];
  }, [apntDet, tempSelectedItem]);

  const getDiagnostics = () => {
    return (services ?? [])
      ?.filter(
        (dl) => dl?.category?.toLowerCase() === diagValues?.type?.toLowerCase(),
      )
      ?.map((dl) => ({
        ...dl,
        name: dl?.serviceName,
        value: dl?.serviceName,
        servicePrice: dl?.serviceVariants?.[0]?.serviceCharge ?? 0,
      }));
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = diagValues?.files?.length > 0 ? [...diagValues?.files] : [];

    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setDiagValues({ ...diagValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onQuesUploadFile = (ques, e) => {
    const fileList = e?.target?.files;
    let fileLists =
      templatevalues?.[ques]?.length > 0 ? [...templatevalues?.[ques]] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => {
        setTemplateValues({ ...templatevalues, [ques]: fileLists });
        // if (ques === "Required File Upload") {
        //   setTemplateFileError(fileLists?.length > 0 ? false : true);
        // }
      })
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleImageRemove = (ind) => {
    const reqFiles = diagValues?.files?.filter((fl, i) => i !== ind);
    setDiagValues({ ...diagValues, files: reqFiles });
  };

  const handleSave = async () => {
    //handle validation
    const err = {};
    const hlp = {};
    if (!diagValues?.testName) {
      err.testName = true;
      hlp.testName = "Test Name is required";
    }
    // if (!diagValues?.variant) {
    //   err.variant = true;
    //   hlp.variant = "Varinat is required";
    // }
    if (!diagValues?.dueDate) {
      err.dueDate = true;
      hlp.dueDate = "Due Date is required";
    }
    if (!diagValues?.quantity || Number(diagValues?.quantity) <= 0) {
      err.quantity = true;
      hlp.dueDate = !diagValues?.quantity
        ? "This field is required"
        : "Value must be grater than or equal to 1";
    }
    if (!diagValues?.collectionTime) {
      err.collectionTime = true;
      hlp.collectionTime = "Collection Time is required";
    }
    if (diagValues?.sampleCollected && !diagValues?.collectedBy?.value) {
      err.collectedBy = true;
      hlp.collectedBy = "This field is required";
    }
    if (Object.keys(err).length > 0) {
      setDiagnosticsErrors({ ...diagnosticsErrors, ...err });
      setDiagnosticsHelpers({ ...diagnosticsHelpers, ...hlp });
      return;
    }
    const appointmentId = appointment?.appoinment?.appointmentId;
    const form = new FormData();
    if (
      selectedItem?.appoinment?.appointmentId
      // apntDet?.appointment?.appointmentDate ===
      // moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD")
    ) {
      form.append("appId", selectedItem?.appoinment?.appointmentId);
    }
    form.append("type", diagValues?.type);
    form.append("testName", diagValues?.testName);
    form.append("doneAt", diagValues?.doneAt);
    form.append("sampleCollected", diagValues?.sampleCollected);
    form.append("priority", diagValues?.priority);
    form.append("quantity", Number(diagValues?.quantity ?? 1));
    form.append("price", Number(diagValues?.price ?? 0));
    form.append("tax", Number(diagValues?.tax ?? 0));
    form.append(
      "total",
      Number(
        (Number(diagValues?.price ?? 0) + Number(diagValues?.tax ?? 0)) *
          Number(diagValues?.quantity ?? 1),
      ),
    );
    form.append(
      "dueDate",
      moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD"),
    );
    form.append("remark", diagValues?.remarks);
    form.append("hsnSacCode", Number(diagValues?.hsnSacCode ?? null));
    if (diagValues?.serviceId) {
      form.append("serviceId", diagValues?.serviceId);
    }
    if (diagValues?.variant ?? diagValues?.variantId) {
      form.append("variantId", diagValues?.variant ?? diagValues?.variantId);
    }
    if (diagValues?.variantName) {
      form.append("variantName", diagValues?.variantName);
    }
    if (
      diagValues?.sampleCollected
      // &&
      // (isEditModal
      //   ? selectedItem?.dueDate !==
      //       moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD") &&
      //     apntDet?.appointment?.appointmentDate ===
      //       moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD")
      //   : apntDet?.appointment?.appointmentDate ===
      //     moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD"))
    ) {
      form.append("addToBilling", true);
    }

    let isFile = false;
    if (
      ["completed", "pending review"].includes(
        (selectedItem?.status ?? "")?.toLowerCase(),
      ) &&
      diagValues?.files?.length === selectedItem?.file?.length
    ) {
      isFile = true;
    }

    if (diagValues?.sampleCollected) {
      // if (diagValues?.files?.length > 0 && !isFile) {
      //   const filePromises = diagValues?.files?.map(async (fle) => {
      //     if (fle?.file) {
      //       return fle?.file; // Local File
      //     } else {
      //       return await urlToFile(fle?.previewUrl); // Remote File
      //     }
      //   });
      //   const finalFiles = await Promise.all(filePromises);
      //   finalFiles?.forEach((file) => {
      //     form.append("file", file);
      //   });
      // }
      if (
        diagValues?.files?.length === 0 ||
        (!diagValues?.files && selectedItem?.file?.length)
      ) {
        form.append("fileDelete", true);
      }
      form.append(
        "collectionTime",
        moment(new Date(diagValues?.collectionTime)).format("HH:mm"),
      );
      form.append("collectedById", diagValues?.collectedBy?.value ?? null);
      form.append("collectedByName", diagValues?.collectedBy?.name ?? null);
    }

    if (!diagValues?.sampleCollected) {
      form.append("status", "Scheduled");
    }
    if (diagValues?.sampleCollected) {
      form.delete("status");
      form.append("status", "In progress");
      // if (diagValues?.files?.length > 0) {
      //   form.delete("status");
      //   form.append("status", "Pending Review");
      // } else {
      //   form.delete("status");
      //   form.append("status", "In progress");
      // }
    }
    if (
      (selectedItem?.status ?? "")?.toLowerCase() === "pending review" &&
      role === "ROLE_DOCTOR"
    ) {
      form.delete("status");
      form.append("status", "Completed");
    }
    if (isFile) {
      form.delete("status");
      form.append("status", selectedItem?.status);
    }

    if (!isEditModal) {
      dispatch(
        createDiagnosticsWoLoader({
          appointmentId:
            selectedItem?.appoinment?.appointmentId ?? appointmentId,
          form,
          formData: true,
        }),
      ).then((res) => {
        if (res?.payload?.status === 200) {
          callApi();
          handleModClose();
          setFileError(false);
          if (diagValues?.sampleCollected) {
            handleEnterResult(res?.payload?.data);
          }
        }
      });
    } else {
      const metaUpdate = { diagnosticsId, form };
      dispatch(updateDiagnosticsWoLoader(metaUpdate)).then((res) => {
        if (res?.payload?.status === 200) {
          callApi();
          handleModClose();
          setFileError(false);
          if (diagValues?.sampleCollected) {
            handleEnterResult(res?.payload?.data);
          }
        }
      });
    }
  };

  const handleModClose = (typ = null) => {
    if (typ === "apiSuccess") callApi();
    setModVisible(false);
    // setDiagValues(initialValues);
    // setDiagnosticsErrors(initialErrors);
    // setDiagnosticsHelpers(initialHelpers);
    setEditModal(false);
    setSelectedItem(null);
    // setTempSelectedItem(null);
    // setTempModVsble(false);
    setDiagnosticsId(null);
  };

  const handleChangeValues = (name, value, addObj) => {
    const reqObj = { ...diagValues, [name]: value };
    const reqValue =
      typeof value == "object" ? (value?.value ?? "")?.toString() : value;
    if (name === "testName") {
      reqObj.price = addObj?.price;
      reqObj.tax = addObj?.tax;
      reqObj.doneAt = addObj.doneAt;
      reqObj.hsnSacCode = addObj?.hsnSacCode;
    }
    if (name === "variant") {
      reqObj.variantId = addObj?.variantId;
      reqObj.variantName = addObj?.variantName;
      const reqVar = getVariantsByServiceId(diagValues?.serviceId)?.find(
        (li) => li?.value === addObj?.variantId,
      );
      reqObj.price = reqVar?.servicePrice ?? 0;
    }
    if (addObj?.serviceId) {
      reqObj.serviceId = addObj?.serviceId;
      const reqVar = getVariantsByServiceId(addObj?.serviceId);
      if (reqVar?.[0]?.variantId) {
        reqObj.variantId = reqVar?.[0]?.variantId;
        reqObj.variantName = reqVar?.[0]?.variantName;
        reqObj.variant = reqVar?.[0]?.variantId;
        reqObj.price = reqVar?.[0]?.servicePrice ?? 0;
      }
    }
    if (name === "sampleCollected" && value) {
      reqObj.dueDate = new Date();
      reqObj.collectionTime = new Date();
    }
    setDiagValues(reqObj);
    setDiagnosticsErrors({
      ...diagnosticsErrors,
      [name]:
        name === "quantity"
          ? (value ?? "")?.toString()?.length > 0 && Number(value) >= 1
            ? false
            : (value ?? "")?.toString()?.length === 0
              ? true
              : true
          : reqValue?.length > 0 || typeof value === "number"
            ? false
            : name === "dueDate"
              ? false
              : name === "collectionTime"
                ? false
                : name === "collectedBy"
                  ? diagValues?.sampleCollected
                  : true,
    });

    setDiagnosticsHelpers({
      ...diagnosticsHelpers,
      [name]:
        name === "quantity"
          ? (value ?? "")?.toString()?.length > 0 && Number(value) >= 1
            ? ""
            : (value ?? "")?.toString()?.length === 0
              ? "This field is required"
              : "Value must be grater than or equal to 1"
          : reqValue?.length > 0 || typeof value === "number"
            ? ""
            : name === "dueDate"
              ? ""
              : name === "collectionTime"
                ? ""
                : name === "collectedBy"
                  ? diagValues?.sampleCollected
                    ? "This field is required"
                    : ""
                  : `${name === "type" ? "Type" : nameExpan?.[name]} is required`,
    });
  };

  const getCollectedByList = () => {
    const reqList = (vets ?? [])
      ?.filter(
        (li) =>
          li?.userRole === "ROLE_CLINIC" ||
          li?.userRole === "ROLE_CLINICADMIN" ||
          li?.userRole === "ROLE_RADIOLOGY" ||
          li?.userRole === "ROLE_DOCTOR",
      )
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
    return reqList;
  };

  const getServiceDetById = (servId, vrntId = null) => {
    if (!servId) return null;
    const reqServ = services?.find((ser) => ser?.serviceId === servId);
    if (vrntId) {
      return (
        reqServ?.serviceVariants?.find((vnt) => vnt?.variantId === vrntId) ?? {}
      );
    }
    return reqServ;
  };

  const getVariantsByServiceId = (servId = null) => {
    if (!servId) return [];
    const servDet = getServiceDetById(servId);
    if (servDet) {
      return servDet?.serviceVariants?.map((vnt) => ({
        ...vnt,
        name: vnt?.variantName,
        value: vnt?.variantId,
      }));
    }
    return [];
  };

  const handleDelete = (diag) => {
    setDiagnosticsId(diag?.diagonosticId);
    setDelModVsble(true);
  };

  const handleEditModal = (diagnostics) => {
    setDiagnosticsId(diagnostics?.diagonosticId);
    setSelectedItem(diagnostics);
    const reqDia = getServiceDetById(diagnostics?.serviceId);
    const [hour, min] =
      diagnostics?.collectionTime?.length > 0
        ? diagnostics?.collectionTime?.split(":")
        : ["00:00"];

    const reqObj = {
      type: diagnostics?.type,
      testName: diagnostics?.testName,
      remarks: diagnostics?.remark,
      dueDate: diagnostics?.dueDate,
      price: reqDia?.servicePrice ?? reqDia?.sellPrice ?? 0,
      tax: reqDia?.tax ?? 0,
      serviceId: reqDia?.serviceId,
      files: diagnostics?.file?.map((fle) => ({ previewUrl: fle })),
      doneAt: diagnostics?.doneAt,
      sampleCollected: diagnostics?.sampleCollected === "Y",
      priority: diagnostics?.priority,
      status: diagnostics?.status,
      collectionTime: new Date(
        new Date().setHours(hour ? hour : 0, min ? min : 0),
      ),
      hsnSacCode: reqDia?.hsnSacCode ?? null,
      collectedBy: null,
      quantity: diagnostics?.quantity ?? 1,
    };
    if (diagnostics?.variantId) {
      reqObj.variantId = diagnostics?.variantId;
      const vnts = getVariantsByServiceId(
        reqDia?.serviceId ?? diagnostics?.serviceId,
      );
      if (vnts?.length > 0) {
        const reqVar = vnts?.find(
          (vt) => vt?.variantId === diagnostics?.variantId,
        );
        if (reqVar) {
          reqObj.variantId = reqVar?.variantId;
          reqObj.variantName = reqVar?.variantName;
          reqObj.variant = reqVar?.variantId;
          reqObj.price = reqVar?.servicePrice;
          reqObj.tax = reqVar?.tax ?? 0;
        }
      }
    }
    if (diagnostics?.collectedById) {
      reqObj.collectedBy = {
        name: diagnostics?.collectedByName,
        value: diagnostics?.collectedById,
      };
    }
    setDiagValues(reqObj);
    setModVisible(true);
    setEditModal(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setDiagnosticsId(null);
  };

  const onCofirmDelete = () => {
    if (!diagnosticsId) return;
    dispatch(deleteDiagnosticsByIdWoLoader(diagnosticsId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        callApi();
      }
    });
  };

  const getReqSampleValue = (itm) => {
    return sampleTypes?.find((st) => st?.value === itm)?.name;
  };

  const getReqModalValue = (itm) => {
    return modalities?.find((st) => st?.value === itm)?.name;
  };

  const handleEnterResult = (itm) => {
    // const reqServ = services?.find((ser) => ser?.serviceId === itm?.serviceId);
    setSelectedItem(itm);
    setModVisible(true);
    // setTempSelectedItem(itm);
    // setTempModVsble(true);

    // if (reqServ?.diagnosticTemplateId && itm?.data?.length > 0) {
    //   dispatch(
    //     getDiagnosticTemplateByIdWoLoader(reqServ?.diagnosticTemplateId),
    //   );
    // }
    // if (itm?.data?.length > 0) {
    //   const vitalIds = [];
    //   let reqObj = {
    //     templateId: reqServ?.diagnosticTemplateId,
    //     resultStatus: itm?.resultStatus ?? null,
    //     status: itm?.status ?? "Pending Review",
    //   };
    //   itm?.data?.forEach((li) => {
    //     if (li?.vitalId) {
    //       vitalIds.push(li?.vitalId);
    //       reqObj = {
    //         ...reqObj,
    //         [`${li?.question}_Indicator`]:
    //           li?.[`${li?.question}_Indicator`] ?? null,
    //       };
    //     }
    //     reqObj = {
    //       ...reqObj,
    //       [li?.question]:
    //         li?.questionType === "shortAnswer" ||
    //         li?.questionType === "paragraph" ||
    //         li?.questionType === "multipleChoice"
    //           ? (li?.answer?.[0] ?? "")
    //           : li?.questionType === "fileupload"
    //             ? li?.files?.length > 0
    //               ? li?.files?.map((fle) => ({ file: null, previewUrl: fle }))
    //               : null
    //             : li?.answer,
    //     };
    //   });
    //   // if (vitalIds?.length > 0) {
    //   //   dispatch(getVitalsByIdsWoLoader(vitalIds));
    //   // }
    //   setTemplateValues(reqObj);
    //   setTempModVsble(true);
    //   return;
    // }
    // if (reqServ?.diagnosticTemplateId) {
    //   dispatch(
    //     getDiagnosticTemplateByIdWoLoader(reqServ?.diagnosticTemplateId),
    //   ).then((res) => {
    //     if (res?.payload) {
    //       const vitalIds = [];
    //       let reqObj = {
    //         templateId: res?.payload?.templateId,
    //         templateName: res?.payload?.templateName,
    //         resultStatus: null,
    //         status: "Pending Review",
    //         type: res?.payload?.type ?? "parameter",
    //       };
    //       if (res?.payload?.type === "report") {
    //         reqObj = { ...reqObj, content: res?.payload?.content ?? "" };
    //       } else {
    //         res?.payload?.question?.forEach((li) => {
    //           reqObj = { ...reqObj, [li?.question]: null };
    //           if (li?.vitalId) {
    //             reqObj = { ...reqObj, [`${li?.question}_Indicator`]: null };
    //             vitalIds.push(li?.vitalId);
    //           }
    //         });
    //         // if (vitalIds?.length > 0) {
    //         //   dispatch(getVitalsByIdsWoLoader(vitalIds));
    //         // }
    //       }
    //       setTemplateValues(reqObj);
    //       setTempModVsble(true);
    //     }
    //   });
    // }
    // if (!reqServ?.diagnosticTemplateId) {
    //   const reqObj = {
    //     templateId: null,
    //     templateName: null,
    //     resultStatus: null,
    //     status: "Pending Review",
    //   };
    //   setTemplateValues(reqObj);
    //   setTempModVsble(true);
    // }
  };

  const onCloseTempMod = () => {
    setTempModVsble(false);
    setTemplateValues({});
    setTempSelectedItem(null);
  };

  const handleChange = (name, value) => {
    setTemplateValues({ ...templatevalues, [name]: value });
  };

  const handleTempImageRemove = (name, ind) => {
    const reqFiles = templatevalues?.[name]?.filter((fl, i) => i !== ind);
    setTemplateValues({ ...templatevalues, [name]: reqFiles });
    // if (name === "Required File Upload") {
    //   setTemplateFileError(reqFiles?.length > 0 ? false : true);
    // }
  };

  const onSaveTemplateValues = async () => {
    // if (
    //   templatevalues?.["Required File Upload"]?.length === 0 ||
    //   !templatevalues?.["Required File Upload"]
    // ) {
    //   return setTemplateFileError(true);
    // }
    const reqObj = {
      resultStatus: templatevalues?.resultStatus,
      status: templatevalues?.status ?? "Pending Review",
    };
    if (templatevalues?.type === "report") {
      reqObj.data = [];
      reqObj.content = templatevalues?.content ?? "";
    }
    if (templatevalues?.type === "parameter" || !templatevalues?.type) {
      const reqList = await Promise.all(
        [defaultFile, ...(diagTemplateById?.question ?? [])]?.map(
          async (li) => {
            const reqObj = {
              question: li?.question,
              answer: Array.isArray(templatevalues?.[li?.question])
                ? templatevalues?.[li?.question]
                : [templatevalues?.[li?.question]],
              questionId: li?.questionId ?? null,
              questionType: li?.questionType,
            };
            if (li?.vitalId) {
              // const matchObj = vitalsByIds?.find(
              //   (vit) => vit?.vitalId === li?.vitalId,
              // );
              reqObj.inputType = li?.inputType ?? null;
              reqObj.vitalGroupId = li?.vitalGroupId;
              reqObj.vitalId = li?.vitalId;
              reqObj.unit = li?.unit ?? null;
              reqObj.lowerRange = li?.lowerRange ?? null;
              reqObj.upperRange = li?.upperRange ?? null;
              reqObj[`${li?.question}_Indicator`] =
                templatevalues?.[`${li?.question}_Indicator`] ?? null;
            }

            if (li?.questionType === "fileupload") {
              delete reqObj.answer;
              const filesList = templatevalues?.[li?.question] || [];
              if (filesList?.length > 0) {
                const form = new FormData();
                // Create an array of promises for all files (convert remote to File)
                const filePromises = filesList?.map(async (fle) => {
                  if (fle?.file) {
                    return fle?.file; // Local File
                  } else {
                    return await urlToFile(fle?.previewUrl); // Remote File
                  }
                });
                // Wait for all file promises to resolve
                const finalFiles = await Promise.all(filePromises);
                // Append all files to the form
                finalFiles?.forEach((file) => {
                  form.append("files", file);
                });
                const res = await dispatch(uploadFilesAndGetUrlWoLoader(form));
                if (res?.payload) {
                  reqObj.files = res.payload.data?.data;
                }
              }
            }
            return reqObj;
          },
        ),
      );
      reqObj.content = null;
      reqObj.data = reqList;
    }
    dispatch(
      addUpdateTemplateByDiagnosticId({
        diagId: tempSelectedItem?.diagonosticId,
        data: reqObj,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseTempMod();
        callApi();
      }
    });
  };

  const onDownloadReport = (itm) => {
    // const reqTempleteId = getServiceDetById(
    //   itm?.serviceId,
    // )?.diagnosticTemplateId;
    // if (reqTempleteId) {
    //   dispatch(getDiagnosticTemplateByIdWoLoader(reqTempleteId));
    // }
    setTempSelectedItem(itm);
    setReportDownVsble(true);
  };

  const onCloseDownMod = () => {
    setReportDownVsble(false);
    setTempSelectedItem(null);
  };

  const renderTableRecord = () => {
    const tdLabel = {
      width: "22%",
      backgroundColor: "#f8f9fb",
      fontWeight: 600,
      color: "#1a1a1a",
      padding: "10px 12px",
      border: "1px solid #dadce0",
      fontSize: 14,
      verticalAlign: "middle",
      boxSizing: "border-box",
    };
    const tdValue = {
      width: "28%",
      backgroundColor: "#fff",
      fontWeight: 400,
      color: "#1a1a1a",
      padding: "10px 12px",
      border: "1px solid #dadce0",
      fontSize: 14,
      verticalAlign: "middle",
      boxSizing: "border-box",
    };
    return (
      <table
        className="diagnostic-report-native-table"
        style={{
          borderCollapse: "collapse",
          width: "100%",
          fontSize: 14,
        }}
      >
        <tbody>
          {diagnosticReportHeaderRows?.map((row, idx) => (
            <tr key={idx}>
              <td style={tdLabel}>{row?.leftLabel}</td>
              <td style={tdValue}>{row?.leftValue || "-"}</td>
              <td style={tdLabel}>{row?.rightLabel}</td>
              <td style={tdValue}>{row?.rightValue || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderCbcResultsTableUi = () => (
    <div className="diagnostic-cbc-results-wrap">
      <table className="diagnostic-cbc-results-table">
        <thead>
          <tr>
            <th>Test Description</th>
            {tempSelectedItem?.data?.some(
              (li) => li?.inputType === "Numeric",
            ) ? (
              <th>Units</th>
            ) : null}
            <th>Result</th>
            {tempSelectedItem?.data?.some(
              (li) => li?.inputType === "Numeric",
            ) ? (
              <th>Reference Range</th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {tempSelectedItem?.data
            ?.filter((li) => li?.questionType !== "fileupload" && li?.vitalId)
            ?.map((row, i) => {
              const lower = row?.lowerRange ?? "";
              const higher = row?.upperRange ?? "";
              let refRange = "";
              if (lower?.length > 0 || higher?.length > 0) {
                refRange = `${lower} - ${higher}`;
              }
              return (
                <tr key={`${Date.now()}_${i}`}>
                  <td>{row?.question}</td>
                  {tempSelectedItem?.data?.some(
                    (li) => li?.inputType === "Numeric",
                  ) ? (
                    <td>{row?.unit?.length ? row?.unit : "\u00A0"}</td>
                  ) : null}
                  <td>
                    {row?.answer?.length
                      ? Array.isArray(row?.answer)
                        ? row?.answer?.join(", ")
                        : (row?.answer ?? "")
                      : "\u00A0"}
                  </td>
                  {tempSelectedItem?.data?.some(
                    (li) => li?.inputType === "Numeric",
                  ) ? (
                    <td>{refRange?.length ? refRange : "\u00A0"}</td>
                  ) : null}
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );

  const handlePrint = useReactToPrint({
    content: () => contentToPrint.current,
    documentTitle: `${tempSelectedItem?.testName}_${Date.now()}`,
    pageStyle: a4PrintConfig,
    removeAfterPrint: true,
    onBeforeGetContent: () => {
      printTitleRef.current = document.title;
      document.title = "";
    },
    onAfterPrint: () => {
      document.title = printTitleRef.current ?? "";
    },
  });

  return (
    <>
      <div className="ph20 mt10">
        <div className="flex-row-ali-cen ph20">
          <div className="w30Per">
            <Typography className="font-bold blue-color fs12">Name</Typography>
          </div>
          <div className="w15Per">
            <Typography className="font-bold blue-color fs12">Type</Typography>
          </div>
          <div className="w15Per">
            <Typography className="font-bold blue-color fs12">
              Sample/Modality
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="font-bold blue-color fs12">
              Status
            </Typography>
          </div>
          <div className="w25Per" />
        </div>
        <div className="blue-hor-split mt5" />
        {getTableRecords()?.length > 0
          ? getTableRecords()?.map((diag) => {
              return (
                <div
                  className="flex-row-ali-cen ph20 mt10"
                  key={diag?.diagonosticId}
                >
                  <div className="w30Per">
                    <Typography className="txt-semi-bold blue-color fs12">
                      {diag?.testName}
                    </Typography>
                  </div>
                  <div className="w15Per">
                    <Typography className="font-medium gray34 fs12">
                      {diag?.type}
                    </Typography>
                  </div>
                  <div className="w15Per">
                    <Typography className="font-medium gray34 fs12">
                      {diag?.sampleCollected
                        ? diag?.type === "Lab"
                          ? getReqSampleValue(
                              getServiceDetById(diag?.serviceId)?.sampleType,
                            )
                          : (getReqModalValue(
                              getServiceDetById(diag?.serviceId)?.modality,
                            ) ?? "")
                        : "Not Yet"}
                    </Typography>
                  </div>
                  <div className="w15Per">
                    <div
                      className={`fs12 con-fit
                  ${
                    (diag?.status ?? "")?.toLowerCase() === "completed"
                      ? "completed2"
                      : (diag?.status ?? "")?.toLowerCase() === "pending"
                        ? "pending2"
                        : "overdue2"
                  }`}
                    >
                      {diagStatusEnum?.[diag?.status]}
                    </div>
                  </div>
                  <div className="w25Per flex1-end">
                    {apntDet?.appointment?.appointmentStatus?.toLowerCase() !==
                      "completed" ||
                    (apntDet?.appointment?.appointmentStatus?.toLowerCase() ===
                      "completed" &&
                      !apntDet?.appointment?.lock) ? (
                      <div className="flex-row-ali-cen">
                        {diag?.sampleCollected === "Y" &&
                        [
                          "pending review",
                          "in progress",
                          "patient review",
                        ]?.includes((diag?.status ?? "")?.toLowerCase()) ? (
                          //   (diag?.status ?? "")?.toLowerCase() ===
                          //     "pending review") ||
                          // (diag?.status ?? "")?.toLowerCase() === "in progress" ||
                          // (diag?.status ?? "")?.toLowerCase() ===
                          //   "patient review"
                          <div
                            className="cursor"
                            onClick={() => handleEnterResult(diag)}
                          >
                            <Typography className="blue-color fs12 txt-semi-bold blu-back white-color ph10 pv5 br5">
                              {diag?.data?.length > 0 ? "Modify" : "Enter"}{" "}
                              Result
                            </Typography>
                          </div>
                        ) : null}
                        {(diag?.status ?? "")?.toLowerCase() === "scheduled" ? (
                          <div
                            className="cursor"
                            onClick={() => handleEditModal(diag)}
                          >
                            <Typography className="blue-color fs12 txt-semi-bold blu-back white-color ph10 pv5 br5">
                              Collect Sample
                            </Typography>
                          </div>
                        ) : null}
                        {/* <div
                          className="cursor ml10"
                          onClick={() => handleEditModal(diag)}
                        >
                          <div className="flex-center">
                            <EditIcon sx={plusBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            Edit
                          </Typography>
                        </div> */}
                        {/* {(diag?.status ?? "")?.toLowerCase() === "scheduled" ? (
                          <div
                            className="cursor ml15"
                            onClick={() => handleDelete(diag)}
                          >
                            <div className="flex-center">
                              <DeleteOutlineIcon sx={delBtn} />
                            </div>
                            <Typography className="red3 fs8 txt-semi-bold text-align-center">
                              Delete
                            </Typography>
                          </div>
                        ) : null} */}
                      </div>
                    ) : null}
                    {(diag?.status ?? "")?.toLowerCase() === "completed" ? (
                      <div
                        className="cursor"
                        onClick={() => onDownloadReport(diag)}
                      >
                        <Typography className="blue-color fs12 txt-semi-bold blu-back white-color ph10 pv5 br5">
                          Print Report {/* Download */}
                        </Typography>
                      </div>
                    ) : null}
                    <div
                      className="cursor ml10"
                      onClick={() => handleDelete(diag)}
                    >
                      <div className="flex-center">
                        <DeleteOutlineIcon sx={delBtn} />
                      </div>
                      <Typography className="red3 fs8 txt-semi-bold text-align-center">
                        Delete
                      </Typography>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
        {apntDet?.appointment?.appointmentStatus?.toLowerCase() !==
          "completed" ||
        (apntDet?.appointment?.appointmentStatus?.toLowerCase() ===
          "completed" &&
          !apntDet?.appointment?.lock) ? (
          <div
            className="flex-row-ali-cen mt20 cursor"
            onClick={() => setModVisible(true)}
          >
            <div className="flex-center plus-icon">
              <AddIcon sx={addIcon} />
            </div>
            <Typography className="blue-color fs16 ml5 font-bold">
              Add
            </Typography>
          </div>
        ) : null}
      </div>
      <DiagnosticReport
        reportDownVsble={reportDownVsble}
        onCloseDownMod={onCloseDownMod}
        selectedItem={tempSelectedItem}
      />

      {/* <CustomModal
        open={reportDownVsble}
        onClose={onCloseDownMod}
        header=""
        modal
        modalWidth={80}
        headerBold
      >
        <div className="scroll-80vh">
          <ContentToPrint
            ref={contentToPrint}
            header={
              <div className="flex-row-ali-cen mv20">
                <div className="w35Per">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w30Per flex-center">
                  <div className="font-bold fs20 blue-color">
                    {getServiceDetById(tempSelectedItem?.serviceId)
                      ?.diagnosticTemplateId
                      ? (diagTemplateById?.templateName ?? "")
                      : "Diagnostic Report"}
                  </div>
                </div>
                <div className="w35Per flex1-end">
                  <div className="prescription-doc-header-clinic">
                    <div className="font-bold blue-color fs16">
                      {clinicDet?.name ?? ""}
                    </div>
                    <div className="txt-regular fs12 blue-color">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          TAX ID:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.taxId ?? ""}
                        </div>
                      </div>
                    ) : null}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  ;
                </div>
              </div>
            }
            footer={
              <div className="prescription-print-footer-inner">
                <div className="mb20 mt10 flex-start prescription-print-footer-doctor-row">
                  <div>
                    <div className="txt-semi-bold fs12 black">
                      Clinician Signature
                    </div>
                  </div>
                </div>
                {clinicDet?.footer?.length > 0 ? (
                  <img src={clinicDet?.footer} alt="" />
                ) : null}
              </div>
            }
          >
            <tr>
              <td className="prescription-print-tbody-cell">
                <div className="prescription-print-body-inner">
                  {renderTableRecord()}
                  {(tempSelectedItem?.content ?? "")?.length > 0 ? (
                    <div
                      className="diagnostic-report-rich-content"
                      dangerouslySetInnerHTML={{
                        __html: normalizeReportHtml(tempSelectedItem?.content),
                      }}
                    />
                  ) : (
                    <>
                      {renderCbcResultsTableUi()}
                      {tempSelectedItem?.data
                        ?.filter(
                          (li) =>
                            !li?.vitalId && li?.questionType !== "fileupload",
                        )
                        ?.map((li, i) => (
                          <div key={`${li?.questionId}_${i}`} className="mv5">
                            <Typography className="txt-semi-bold fs14 black">
                              {li?.question}
                            </Typography>
                            <Typography className="txt-regular fs14 black">
                              {Array.isArray(li?.answer)
                                ? li?.answer?.join(", ")
                                : typeof li?.answer === "string"
                                  ? li?.answer
                                  : ""}
                            </Typography>
                          </div>
                        ))}
                    </>
                  )}
                </div>
              </td>
            </tr>
          </ContentToPrint>
          <div className="flex1-end mv20">
            <div>
              <CustomButton text="Print" onClick={handlePrint} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal> */}
      {/* <CustomModal
        open={tempModVsble}
        onClose={onCloseTempMod}
        header={tempSelectedItem?.testName}
        modal
        modalWidth={70}
        headerBold
      >
        <div className="scroll-80vh ph20">
          <div className="flex-row-ali-cen">
            <Typography className="txt-semi-bold fs16 black">Type:</Typography>
            <Typography className="font-medium fs16 black3 ml5">
              {tempSelectedItem?.type}
            </Typography>
            <Typography className="txt-semi-bold fs16 black ml10">
              Variant:
            </Typography>
            <Typography className="font-medium fs16 black3 ml5">
              {
                getServiceDetById(
                  tempSelectedItem?.serviceId,
                  tempSelectedItem?.variantId,
                )?.variantName
              }
            </Typography>
            <Typography className="txt-semi-bold fs16 black ml10">
              Collected by:
            </Typography>
            <Typography className="font-medium fs16 black3 ml5">
              {tempSelectedItem?.collectedByName}
            </Typography>
          </div>
          <div className="blue-hor-split mv10" />
          {templatevalues?.type === "report" ? (
            ckEditorBuild ? (
              <div className="mv20">
                <CKEditor
                  editor={ckEditorBuild}
                  disableWatchdog
                  data={templatevalues?.content}
                  onChange={(event, editor) => {
                    const value = editor?.getData();
                    handleChange("content", value);
                  }}
                />
              </div>
            ) : null
          ) : (
            [defaultFile, ...(diagTemplateById?.question ?? [])]?.map(
              (ques, i) => {
                let answers = ques?.answer;
                let matchObj = null;
                let questionType = ques?.questionType;
                // if (ques?.vitalId) {
                //   matchObj = vitalsByIds?.find(
                //     (vit) => vit?.vitalId === ques?.vitalId,
                //   );
                //   answers = matchObj?.dropdown ?? [];
                //   if (matchObj?.inputType === "DropDown") {
                //     questionType = "dropdown";
                //   }
                // }

                return (
                  <div key={`${ques?.questionId} ${i}`} className="mv5">
                    <div className="flex-row-between">
                      <div
                        className={
                          ques?.vitalId && ques?.inputType === "Numeric"
                            ? "w48Per"
                            : "w100Per"
                        }
                      >
                        <Typography className="font-medium fs16 black">
                          {ques?.question}{" "}
                        </Typography>
                        {matchObj?.unit?.length > 0 && (
                          <Typography className="font-medium fs14 gray3">
                            {matchObj?.unit}
                          </Typography>
                        )}
                        <div className="mv5">
                          {questionType === "shortAnswer" ||
                          questionType === "paragraph" ? (
                            <CustomTextField
                              fullWidth
                              value={templatevalues?.[ques?.question]}
                              multiline={ques?.questionType === "paragraph"}
                              handleChange={(e) =>
                                handleChange(ques?.question, e?.target?.value)
                              }
                            />
                          ) : questionType === "multipleChoice" ? (
                            <CustomCheckbox
                              radios={answers?.map((rd) => ({
                                label: rd,
                                value: rd,
                              }))}
                              defaultValue={templatevalues?.[ques?.question]}
                              radio
                              onChange={(e) => {
                                handleChange(ques?.question, e?.target?.value);
                              }}
                              isRow={false}
                            />
                          ) : questionType === "checkboxes" ? (
                            <div className="ml10">
                              <CustomCheckboxGroup
                                list={answers?.map((li) => ({
                                  label: li,
                                  value: li,
                                }))}
                                value={templatevalues?.[ques?.question] ?? []}
                                onChange={(e) => {
                                  handleChange(ques?.question, e);
                                }}
                              />
                            </div>
                          ) : questionType === "dropdown" ? (
                            <CustomSelect
                              list={answers?.map((li) => ({
                                name: li,
                                value: li,
                              }))}
                              value={templatevalues?.[ques?.question]}
                              name={ques?.question}
                              // label={`${ques?.question}__Indicator`}
                              select
                              handleChange={(e) =>
                                handleChange(ques?.question, e?.target?.value)
                              }
                            />
                          ) : (
                            <div>
                              {templatevalues?.[ques?.question]?.length > 0 ? (
                                <div className="mt20">
                                  <FilesWithCloseButton
                                    files={templatevalues?.[ques?.question]}
                                    onClickFile={(i, file) =>
                                      handleTempImageRemove(ques?.question, i)
                                    }
                                  />
                                </div>
                              ) : null}
                              <div className="mt20">
                                <CustomUpload
                                  onUploadFile={(e) =>
                                    onQuesUploadFile(ques?.question, e)
                                  }
                                  multipleNew
                                  multiFiles
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {ques?.vitalId && ques?.inputType === "Numeric" ? (
                        <div className="w48Per">
                          <Typography className="font-medium fs16 black">
                            Indicator
                          </Typography>
                          {matchObj?.unit?.length > 0 && (
                            <Typography className="font-medium fs14 gray3">
                              Ref: {matchObj?.lowerRange ?? ""} -{" "}
                              {matchObj?.upperRange ?? ""}
                            </Typography>
                          )}
                          <div className="mv5">
                            <CustomSelect
                              list={[
                                { name: "Normal", value: "Normal" },
                                { name: "Cretical", value: "Cretical" },
                              ]}
                              value={
                                templatevalues?.[`${ques?.question}_Indicator`]
                              }
                              name={`${ques?.question}_Indicator`}
                              // label={`${ques?.question}__Indicator`}
                              select
                              handleChange={(e) =>
                                handleChange(
                                  `${ques?.question}_Indicator`,
                                  e?.target?.value,
                                )
                              }
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              },
            )
          )}
          <Typography className="font-medium fs16 black">
            Result Status
          </Typography>
          <div>
            <CustomSelect
              list={[
                { name: "Preliminary", value: "Preliminary" },
                { name: "Final", value: "Final" },
              ]}
              value={templatevalues?.resultStatus}
              name="resultStatus"
              select
              handleChange={(e) =>
                handleChange("resultStatus", e?.target?.value)
              }
            />
          </div>

          <Typography className="font-medium fs16 black mt10">
            Status
          </Typography>
          <div>
            <CustomSelect
              list={
                diagVetStatusList
                // role === "ROLE_DOCTOR" ? diagVetStatusList : diagOtherStatusList
              }
              value={templatevalues?.status}
              name="status"
              select
              handleChange={(e) => handleChange("status", e?.target?.value)}
            />
          </div>

          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Save"
                smallBtn
                onClick={onSaveTemplateValues}
              />
            </div>
          </div>
        </div>
      </CustomModal> */}

      <DiagnosticAddUpdate
        modVisible={modVisible}
        handleModClose={handleModClose}
        selectedItem={selectedItem}
      />
      {/* <CustomModal
        open={modVisible}
        onClose={handleModClose}
        header={isEditModal ? "Edit" : "Add"}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomSelect
                list={diagnosticTypes}
                value={diagValues?.type}
                error={diagnosticsErrors?.type}
                helperText={diagnosticsHelpers?.type}
                name="type"
                label={nameExpan?.["type"]}
                select
                handleChange={(e) => {
                  handleChangeValues("type", e?.target?.value);
                }}
                disabled={isEditModal}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={getDiagnostics()}
                value={diagValues?.testName}
                name="testName"
                label={nameExpan?.["testName"]}
                newSelect
                handleChange={(e) => {
                  handleChangeValues("testName", e?.value, {
                    price: e?.servicePrice ?? 0,
                    tax: e?.tax ?? 0,
                    serviceId: e?.serviceId ?? null,
                    doneAt: e?.doneAt ?? null,
                    hsnSacCode: e?.hsnSacCode ?? null,
                  });
                }}
                error={diagnosticsErrors?.testName}
                helperText={diagnosticsHelpers?.testName}
                disabled={isEditModal}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={getVariantsByServiceId(diagValues?.serviceId ?? null)}
                value={diagValues?.variant}
                name="variant"
                label={nameExpan?.["variant"]}
                newSelect
                handleChange={(e) => {
                  handleChangeValues("variant", e?.value, {
                    variantName: e?.variantName,
                    variantId: e?.value,
                  });
                }}
                error={diagnosticsErrors?.variant}
                helperText={diagnosticsHelpers?.variant}
                disabled={isEditModal}
                // mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                Quantity <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="quantity"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("quantity", e?.target?.value)
                }
                value={diagValues?.quantity}
                error={diagnosticsErrors?.quantity}
                helperText={diagnosticsHelpers?.quantity}
                disabled={
                  selectedItem?.sampleCollected === "Y" ||
                  diagValues?.sampleCollected
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                Due Date <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="dueDate"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("dueDate", e?.target?.value)
                }
                value={diagValues?.dueDate}
                error={diagnosticsErrors?.dueDate}
                helperText={diagnosticsHelpers?.dueDate}
                mobileDate
                disabled={
                  selectedItem?.sampleCollected === "Y" ||
                  diagValues?.sampleCollected
                }
              />
            </Grid>
            {diagValues?.type === "Laboratory Test" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="font-medium fs14 gray7">
                  {nameExpan?.["sampleType"]}
                </div>
                <CustomTextField
                  value={getServiceDetById(diagValues?.serviceId)?.sampleType}
                  fullWidth
                  disabled
                />
              </Grid>
            )}
            {diagValues?.type === "Radiology Test" && (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="font-medium fs14 gray7">
                    {nameExpan?.["modality"]}
                  </div>
                  <CustomTextField
                    value={getServiceDetById(diagValues?.serviceId)?.modality}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="font-medium fs14 gray7">
                    {nameExpan?.["device"]}
                  </div>
                  <CustomTextField
                    value={getServiceDetById(diagValues?.serviceId)?.device}
                    fullWidth
                    disabled
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomSelect
                list={doneAtList}
                value={diagValues?.doneAt}
                error={diagnosticsErrors?.doneAt}
                helperText={diagnosticsHelpers?.doneAt}
                name="doneAt"
                label={nameExpan?.["doneAt"]}
                select
                handleChange={(e) => {
                  handleChangeValues("doneAt", e?.target?.value);
                }}
                disabled={selectedItem?.sampleCollected === "Y"}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                {nameExpan?.["processingTime"]}
              </div>
              <CustomTextField
                value={
                  getServiceDetById(
                    diagValues?.serviceId,
                    diagValues?.variantId ?? null,
                  )?.estimatedDuration ?? ""
                }
                fullWidth
                disabled
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="mtMin10"
            >
              <CustomCheckbox
                label="Sample Collected"
                checked={diagValues?.sampleCollected}
                onChange={() =>
                  handleChangeValues(
                    "sampleCollected",
                    !diagValues?.sampleCollected,
                  )
                }
                disabled={selectedItem?.sampleCollected === "Y"}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={priorityList}
                value={diagValues?.priority}
                error={diagnosticsErrors?.priority}
                helperText={diagnosticsHelpers?.priority}
                name="priority"
                label={nameExpan?.["priority"]}
                select
                handleChange={(e) => {
                  handleChangeValues("priority", e?.target?.value);
                }}
                disabled={isEditModal}
                mandatoryField
              />
            </Grid>
            {diagValues?.sampleCollected && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomTextField
                    name="collectionTime"
                    fullWidth
                    mobileTime
                    handleChange={(e) =>
                      handleChangeValues("collectionTime", e?.target?.value)
                    }
                    value={diagValues?.collectionTime}
                    error={diagnosticsErrors?.collectionTime}
                    helperText={diagnosticsHelpers?.collectionTime}
                    is12HourFomat={false}
                    label={nameExpan["collectionTime"]}
                    disabled={selectedItem?.sampleCollected === "Y"}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomSelect
                    list={getCollectedByList()}
                    value={diagValues?.collectedBy}
                    name="collectedBy"
                    label={nameExpan?.["collectedBy"]}
                    search
                    handleChange={(e, value) => {
                      handleChangeValues("collectedBy", value);
                    }}
                    error={diagnosticsErrors?.collectedBy}
                    helperText={diagnosticsHelpers?.collectedBy}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label={nameExpan?.["remarks"]}
                placeholder="Remarks"
                name="remarks"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("remarks", e?.target?.value)
                }
                value={diagValues?.remarks}
                error={diagnosticsErrors?.remarks}
                helperText={diagnosticsHelpers?.remarks}
                multiline
                disabled={
                  (selectedItem?.status ?? "")?.toLowerCase() === "completed"
                    ? true
                    : false
                }
              />
            </Grid>

            {diagValues?.files?.length > 0 ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FilesWithCloseButton
                  files={diagValues?.files}
                  onClickFile={(i, file) => handleImageRemove(i)}
                  disabled={
                    (selectedItem?.status ?? "")?.toLowerCase() === "completed"
                    //  ||
                    // selectedItem?.status?.toLowerCase() === "pending review"
                  }
                />
              </Grid>
            ) : null}

            {fileError ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormHelperText error>File is required</FormHelperText>
              </Grid>
            ) : null}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-center">
                <div>
                  <CustomButton
                    text={
                      (selectedItem?.status ?? "")?.toLowerCase() ===
                        "pending review" && role === "ROLE_DOCTOR"
                        ? "Reviewed"
                        : "Submit"
                    }
                    smallBtn
                    onClick={handleSave}
                    disabled={
                      (selectedItem?.status ?? "")?.toLowerCase() ===
                      "completed"
                      //  ||
                      // (selectedItem?.status?.toLowerCase() ===
                      //   "pending review" &&
                      //   role !== "ROLE_DOCTOR")
                    }
                    grayBtn={
                      (selectedItem?.status ?? "")?.toLowerCase() ===
                      "completed"
                      //  ||
                      // (selectedItem?.status?.toLowerCase() ===
                      //   "pending review" &&
                      //   role !== "ROLE_DOCTOR")
                    }
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal> */}

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the diagnostics?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="Yes" redBtn onClick={onCofirmDelete} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PetDiagnostics;
